import { CardActions } from '../../../State/Card/CardActions';
import { AnyBoosterType } from '../../../State/Card/BoosterType';
import CardSystem from '../CardSystem';
import ITask from 'Utility/Task/ITask';

export class PlayAnyBoosterTask implements ITask<CardSystem> {
    private readonly boosterType: AnyBoosterType;

    public constructor(boosterType: AnyBoosterType) {
        this.boosterType = boosterType;
    }

    *execute(system: CardSystem) {
        CardActions.playBooster(this.boosterType);
    }
}
